import React from "react";
import { Box, TextField, MenuItem, IconButton, Autocomplete } from "@mui/material";
import { AddCircleOutlineOutlined } from "@mui/icons-material";

const CustomSelect = ({
  label,
  handleAddClick,
  add,
  required,
  value,
  handleChange,
  error,
  helperText,
  name,
  data,
  placeholder = "",
  minWidth = "",
  searchable = false,
  disabled = false,
  isLoading = false,
}) => {
  let options = [];

  if (isLoading) {
    options = [];
  } else if (!isLoading && (!data || data.length === 0)) {
    options = [];
  } else {
    options = data;
  }

  return (
    <Box display="flex" alignItems="center" gap={1} width="100%" mt={2} minWidth={minWidth}>
      {/* Autocomplete for searchable select */}
      {searchable ? (
        <Autocomplete
          options={options}
          loading={isLoading}
          disabled={disabled} 
          value={
            typeof value === "object"
              ? value
              : options.find((opt) => (typeof opt === "object" ? opt.value === value : opt === value)) || null
          }
          getOptionLabel={(option) => (typeof option === "object" ? option.value : option)}
          isOptionEqualToValue={(option, val) =>
            typeof option === "object" && typeof val === "object" ? option.value === val.value : option === val
          }
          onChange={(e, newValue) => {
            if (typeof newValue === "object" && newValue?.isSpecial) {
              handleAddClick?.(label);
            } else {
              handleChange({
                target: {
                  name,
                  value: typeof newValue === "object" ? newValue?.value : newValue,
                },
              });
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              name={name}
              required={required}
              error={error}
              helperText={helperText}
              placeholder={placeholder}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                handleChange({
                  target: {
                    name,
                    value: e.target.value,
                  },
                });
              }}
              sx={{
                "& .MuiInputLabel-root": {
                  fontSize: "18px",
                  background: "white",
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                },
                "& input::placeholder": {
                  fontSize: "12px",
                },
                "& .MuiInputBase-root": {
                  borderRadius: "8px",
                  height: "40px",
                  "& fieldset": {
                    borderColor: "black",
                  },
                  "&:hover fieldset": {
                    borderColor: "black",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "black",
                  },
                },
              }}
            />
          )}
          fullWidth
        />
      ) : (
        <TextField
          select
          label={label}
          name={name}
          value={value}
          fullWidth
          InputLabelProps={{ shrink: true }}
          disabled={disabled}
          onChange={(e) =>
            handleChange({
              target: { name: name, value: e.target.value },
            })
          }
          error={error}
          helperText={helperText}
          sx={{
            "& .MuiInputLabel-root": {
              fontSize: "18px",
              background: "white",
              "&::after": {
                content: required ? '"*"' : '""',
                color: "red",
                marginLeft: "2px",
                background: "white",
              },
            },
            "& input::placeholder": {
              fontSize: "12px",
            },
            "& .MuiInputBase-root": {
              borderRadius: "8px",
              height: "40px",
              "& fieldset": {
                borderColor: "black",
              },
              "&:hover fieldset": {
                borderColor: "black",
              },
              "&.Mui-focused fieldset": {
                borderColor: "black",
              },
            },
          }}>
          {options.map((item, index) => (
            <MenuItem key={index} value={item}>
              {item}
            </MenuItem>
          ))}
        </TextField>
      )}

      {/* Add Button */}
      {add && (
        <IconButton
          onClick={() => handleAddClick(label)}
          sx={{
            border: "1px solid",
            borderRadius: "8px",
            padding: "8px",
            "&:hover": {
              backgroundColor: "#F1F5F9",
            },
          }}>
          <AddCircleOutlineOutlined />
        </IconButton>
      )}
    </Box>
  );
};

export default CustomSelect;